/** Tableau de bord formateur d’une formation (EduFlow). */
export function formateurFormationDashboardPath(flowId: string): string {
  return `/dashboard/formation/${encodeURIComponent(flowId)}`;
}

/** Tableau de bord formateur d’un podcast. */
export function formateurPodcastDashboardPath(podcastId: string): string {
  return `/dashboard/podcast/${encodeURIComponent(podcastId)}`;
}
